import { IconButton, Menu, MenuButton, Portal } from '@chakra-ui/react';
import { MenuList, MenuItem } from '@/components/v4';
import { useSelector } from 'react-redux';
import { BsThreeDotsVertical } from 'react-icons/bs';

const ActionMenu = ({ actionItems }) => {
    const { darkMode } = useSelector((state) => state.settings);
    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',
            }}>
            <Menu>
                <MenuButton
                    as={IconButton}
                    variant="ghost"
                    aria-label="Edit Menu"
                    icon={
                        <BsThreeDotsVertical
                            fill={darkMode ? 'white' : 'black'}
                        />
                    }
                />
                <Portal>
                    <MenuList>
                        {actionItems.map((item, index) => (
                            <MenuItem key={index} onClick={item.onClick}>
                                {item.label}
                            </MenuItem>
                        ))}
                    </MenuList>
                </Portal>
            </Menu>
        </div>
    );
};

export default ActionMenu;
